import { render, staticRenderFns } from "./EditLocationMapping.vue?vue&type=template&id=b05bb5ee&"
import script from "./EditLocationMapping.vue?vue&type=script&lang=js&"
export * from "./EditLocationMapping.vue?vue&type=script&lang=js&"
import style0 from "./EditLocationMapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports